<template>
  <div class="header" :class="{ 'footer-margin-75' : footerMoreSpace }">
    <div class="header-item">
      <div v-if="cover[1] == 'image'" class="header-item-1" :style="{backgroundImage: 'url(' + cover[0] + ')'}"></div>
      <video v-if="cover[1] == 'video'" class="header-video" width="320" height="240" autoplay loop muted>
        <source :src="cover[0]" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="header-curve" :style="{ backgroundImage : 'url(/static/img/headers/curve2.png)' }"></div>
    <div class="header-footer" :class="{ 'footer-bottom-75': footerMoreSpace }">
      <div class="header-footer-left">
        <span v-if="date">{{date}}</span>
        <h1 v-if="texts[0]">{{texts[0]}}</h1>
        <h4 v-if="texts[1]">{{texts[1]}}</h4>
      </div>
    </div>
    <div class="slide-animation" v-if="!hideScroll">
      <img class="mouse" src="/static/img/scroll.svg" alt="">
    </div>
  </div>
</template>

<script>
// object fit polyfill for IE/EDGE
import objectFitVideos from "../../../node_modules/object-fit-videos/dist/object-fit-videos.min.js";
export default {
  // Array with all the slides is received as props
  // Every slide is another array with 1 or 3 images inside
  // slide 1 is also an array with two strings ['source', 'image/video']
  props: ["cover", "texts", "hideScroll", "date", "footerMoreSpace"],
  mounted() {
    objectFitVideos(document.querySelectorAll(".header-video"));
    objectFitVideos(document.querySelectorAll(".header-item-3"));
  }
};
</script>

<style scoped>
.header {
  height: 100vh;
  /* overflow: hidden; */
  position: relative;
}
.header-curve {
  background-position: bottom;
  background-size: 100% 100%;
  bottom: -1px;
  height: 250px;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 2;
}
.header-footer span {
  color: rgba(26, 67, 124, 0.7);
  font-size: 12px;
}
.header-footer h1 {
  font-size: 32px;
  font-weight: 500;
  margin-bottom: 10px;
}
.header-footer h4 {
  font-size: 16px;
  line-height: 20px;
}
.header-footer {
  align-items: center;
  bottom: 0;
  display: flex;
  height: 200px;
  justify-content: space-between;
  padding: 0 40px;
  position: absolute;
  width: 38%;
  z-index: 5;
}
.slide-animation {
  align-items: center;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  height: 65;
  justify-content: flex-start;
  position: absolute;
  right: 80px;
  width: 38px;
  z-index: 5;
}
.mouse {
  height: 65px;
  width: 100%;
}
.header-item {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}
/* PART 1 */
.header-item-1 {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100%;
  z-index: 1;
}
.header-video {
  font-family: "object-fit: cover; object-position: center;";
  object-fit: cover;
  -o-object-fit: cover;
  object-position: center;
  -o-object-position: center;
  height: 100%;
  width: 100%;
  z-index: 1;
}
/* ANIMATIONS */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.gradient {
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 );
  bottom: 0;
  height: 200px;
  position: absolute;
  width: 100%;
  z-index: 4;
}
/* END OF ANIMATIONS */
@media screen and (max-width: 1600px) {
  .header-footer {
    padding: 0 40px;
    width: 40%;
  }
}
@media screen and (max-width: 1440px) {
  .header-footer {
    width: 45%;
  }
}
@media screen and (max-width: 1280px) {
  .header {
    /* this is for vh to work on mobile devices  */
    height: calc(var(--vh, 1vh) * 100);
  }
  .header-footer {
    height: 150px;
    width: 60%;
  }
  .header-curve {
    background-position: left;
    background-size: cover;
  }
}
/* MOBILE */
@media screen and (max-width: 1000px) {
  .slide-animation,
  .mouse {
    display: none;
  }
  .header {
    height: 200px;
    max-height: initial;
    margin-bottom: 25px;
    min-height: initial;
    overflow: initial;
  }
  .header-curve {
    background-size: 100% 100%;
    height: 60px;
  }
  .header-footer {
    align-items: flex-end;
    bottom: -25px;
    height: 50px;
    padding: 0 30px;
    width: 100%;
  }
  .header-footer h1 {
    font-size: 20px;
    margin-bottom: 0;
  }
  .footer-margin-75 {
    margin-bottom: 75px;
  }
  .footer-bottom-75 {
    bottom: -75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Header.vue